export type HasLanguage = {
    language: Language;
};

export enum Language {
    Russian = `RU`,
    English = `EN`,
    Turkish = `TR`,
}

export default function convertToLanguageMap<T extends HasLanguage>(texts: T[]): Map<Language, T> {
    return new Map<Language, T>(texts.map((value) => [value.language, value]));
}

export type LanguageKeyObject<T = string> = { [K in Language]?: T };

export const initLanguageMap = (): LanguageKeyObject => ({
    [Language.Russian]: ``,
    [Language.English]: ``,
    [Language.Turkish]: ``,
});

export const title = <T extends HasLanguage>(texts: T[]): string => getLanguageField(texts, `title`);
export const description = <T extends HasLanguage>(texs: T[]): string => getLanguageField(texs, `description`);

export const getLanguageField = <T extends HasLanguage>(
    texts: T[],
    field: string,
    language = Language.Russian,
): string => {
    const text = texts.find((row: T): boolean => row.language === language);

    return text ? text[field] : ``;
};
